import apiClient from './apiClient';

export type ModuleTestStatus = 'untested' | 'has_bug' | 'bug_fixed' | 'verified';
export type DevModuleStatus = '--' | 'wip' | 'done' | 'bug' | 'blocked';

export interface ModuleStatusRecord {
  moduleKey: string;
  status: ModuleTestStatus;
  notes: string;
  updatedBy: string;
  updatedAt: string;
}

export type StatusMap = Record<string, ModuleStatusRecord>;

export interface DevModuleRecord {
  formId: string;
  status: DevModuleStatus;
}

interface DevModulesResponse {
  data: DevModuleRecord[];
  total?: number;
}

export const erpHomeApi = {
  getStatuses: () =>
    apiClient.get<StatusMap>('/api/erp/statuses').then((r) => r.data),

  updateStatus: (key: string, status: ModuleTestStatus, notes?: string) =>
    apiClient
      .put<ModuleStatusRecord>(`/api/erp/statuses/${key}`, { status, notes: notes || '' })
      .then((r) => r.data),

  getFavorites: () =>
    apiClient.get<string[]>('/api/erp/favorites').then((r) => r.data),

  toggleFavorite: (key: string) =>
    apiClient
      .post<{ action: 'added' | 'removed'; moduleKey: string }>(`/api/erp/favorites/${key}`)
      .then((r) => r.data),

  getDevModules: async (pageSize: number = 200) => {
    const modules: DevModuleRecord[] = [];
    let page = 1;
    let total = Number.POSITIVE_INFINITY;

    while (modules.length < total) {
      const response = await apiClient.get<DevModulesResponse>('/api/dev/modules', {
        params: { page, size: pageSize },
      });
      const batch = response.data.data || [];
      const nextTotal = typeof response.data.total === 'number'
        ? response.data.total
        : modules.length + batch.length;

      modules.push(...batch);
      total = nextTotal;

      if (batch.length === 0 || batch.length < pageSize) {
        break;
      }

      page += 1;
    }

    return modules;
  },

  updateDevModuleStatus: (formId: string, status: DevModuleStatus) =>
    apiClient
      .put<{ data: DevModuleRecord }>(`/api/dev/modules/${formId}`, { status })
      .then((r) => r.data.data),
};
